import { connect } from 'react-redux';
import ESSPoints from './ESSPoints';
import { getAnnualResults } from '../selectors';

import { setSelectedFinancing } from '../../../../common/settings/actions';

const mapStateToProps = state => ({
    annualResults: getAnnualResults(state),
    selectedFinancing: state.settings.selectedFinancing,
    ppaRate: state.ppa.rate,
    ppaTerm: state.ppa.term,
    ppaEscalator: state.ppa.escalator,
    loanTerm: state.loan.loanTerm,
    showCAP: state.cap.showCAP,
    downPayment: state.loan.downPayment,
    loanInterest: state.loan.interest,
    cashprice: state.solar.cashprice,
    systemSize: state.solar.systemSize,
    provider: state.utility.provider,
    annualInflation: state.utility.annualInflation,
    setSelectedFinancing,
    doughnutSlider: state.settings.doughnutSlider,
    taxEntity: state.tax.taxEntity,
    projectState: state.projectaddress.projectState,
    sgipToggle: state.sgip.sgipToggle,
    includeESS: state.ess.includeESS,
    essPrice: state.ess.essPrice,
    batteryType: state.ess.batteryType,
    resiToggle: state.tax.resiToggle,
    taxRate: state.tax.taxRate,
    projectName: state.projectaddress.projectName,
    loanProvider: state.loan.loanProvider,
    mosaicFee: state.loan.mosaicFee,
    mosaicTerm: state.loan.mosaicTerm,
    showLoan: state.loan.showLoan,
    companyName: state.clientInfoUI.companyName,
    firstName: state.contactUI.firstName,
    lastName: state.contactUI.lastName,
});

const combinedActions = {
    setSelectedFinancing,
};

export default connect(mapStateToProps, combinedActions)(ESSPoints);



// WEBPACK FOOTER //
// ./src/containers/Simulator/TabBar/Results/ESSPoints/index.js